import { Grid } from "@mui/material";
import React from "react";
import AdminRolesDashboard from "shared/components/projectHeadComponents/controlCenter/adminRolesDashboard";
import ManageGenreOnLandingPages from "shared/components/projectHeadComponents/controlCenter/manageGenreOnLandingPages";
import OtherDifferentControlsProjectHead from "shared/components/projectHeadComponents/controlCenter/otherDifferentControlsProjectHead";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import { routeConstant } from "shared/routes/routesConstant";
import styles from "./style.module.scss"

function PhNewControlCenter() {
  useBreadcrumbs({
    title: "Control Center",
    path: routeConstant?.controlCenter?.path,
  });

  return (
    <div className={styles.mainContainer}>
      <AdminRolesDashboard />
      <Grid container spacing={2}>
        <Grid item xs={12} xl={7}>
          <ManageGenreOnLandingPages />
        </Grid>
        <Grid item xs={12} xl={5}>
          <OtherDifferentControlsProjectHead />
        </Grid>
      </Grid>
    </div>
  );
}

export default PhNewControlCenter;
